var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"claim-type-step-claim-item flex row-gap-8 col-gap-8",class:_vm.wrapperClasses},[_c('vs-textarea',{staticClass:"claim-item-text-area w-full",attrs:{"disabled":""}}),_c('div',{staticClass:"btn-area flex gap-3"},[_c('common-button',{staticClass:"save-btn-template",attrs:{"title":"保存","type":"filled","click":() => {},"btnStyle":{
        paddingLeft: 0,
        paddingRight: 0,
        width: '70px',
        height: '40px',
      },"disabled":""}}),_c('common-button',{staticClass:"cancel-btn-template",attrs:{"type":"border","color":"#BDBDBD","click":() => {},"btnStyle":{
        paddingLeft: 0,
        paddingRight: 0,
        width: '70px',
        height: '40px',
        fontSize: '12px',
        pointerEvents: 'none',
      },"text-color":"#757575","title":"キャンセル"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }